import Dialogs from "oc-ui/dialogs/DialogsBootstrap3";
import HBS from "oc-ui/hbs/HBS";

let container = 'body';

function removeOnHide(dialog) {
    dialog.on('hidden.bs.modal', function () {
        $(this).data('bs.modal', null);
        dialog.remove();
    });
}

Dialogs.showWarning = (message) => {
    const a = HBS('oc-ui/dialogs/warning.hbs')({message});
    const dialog = $(a);
    $(container).append(dialog);
    dialog.modal({
        backdrop: false
    });
    removeOnHide(dialog);
    return {hide: () => {
            dialog.modal('hide');
        }};
};

Dialogs.showError = (message) => {
    const dialog = $(HBS('oc-ui/dialogs/error.hbs')({message}));
    $(container).append(dialog);
    dialog.modal({
        backdrop: false
    });
    removeOnHide(dialog);
    return {hide: () => {
            dialog.modal('hide');
        }};
};

Dialogs.askQuestion = (message, buttonAndActionList) => {
    const dialog = $(HBS('oc-ui/dialogs/question.hbs')({message}));
    const footer = $('.modal-footer',dialog);
    buttonAndActionList.forEach(b=>{
        b.class_ = b.class_ || (b.primary?'btn-primary':'');
        const button = $(HBS('oc-ui/dialogs/questionButton.hbs')(b));
        button.on('tap',()=>{
            hide();
            if (b.action) {
                b.action();
            }
        });
        footer.append(button);
    });
    function hide() {
        dialog.modal('hide');
    }
    dialog.modal({
        backdrop: false
    });
    removeOnHide(dialog);
    return {hide};
};
